import { RiShareForwardFill } from "react-icons/ri";

import { analytics } from "MVVM/Analytics";
import { useCopyLink } from "MVVM/Views/Match/useCopyLink";
import { ShareButton } from "MVVM/Views/Match/styledComponents";

type TShareMatchButtonProps = {
  matchId: string;
  playerGameId: string;
  tabName: string;
};

// The route is public but player-scoped, and the ViewModel falls back to the
// viewer's own steamid when playerGameId is missing. A link without it shows a
// signed-out recipient someone else's match, or nothing at all.
export const buildShareUrl = (
  matchId: string,
  playerGameId: string,
  tabName: string,
) => {
  const url = new URL(`${window.location.origin}/match/${matchId}`);
  if (playerGameId) url.searchParams.set("playerGameId", playerGameId);
  url.searchParams.set("tab", tabName);
  url.searchParams.set("utm_source", "match_share");
  return url.toString();
};

export const ShareMatchButton = ({
  matchId,
  playerGameId,
  tabName,
}: TShareMatchButtonProps) => {
  const { copied, copy } = useCopyLink();

  const handleShare = async () => {
    const ok = await copy(buildShareUrl(matchId, playerGameId, tabName));
    if (!ok) return;
    analytics.track("Button - Click", {
      location: "match",
      locationIdentifier: "shareMatch",
      source: "website",
    });
  };

  return (
    <ShareButton
      type="button"
      $copied={copied}
      aria-live="polite"
      onClick={handleShare}
    >
      <RiShareForwardFill size={14} aria-hidden />
      {copied ? "Link Copied!" : "Share"}
    </ShareButton>
  );
};
